<template>
	<pop-up-wrapper>
		<div class="pop-up-new-folder">
			<p class="title">Nom du fichier</p>
			<form @submit.prevent="submit">
				<input
					ref="name"
					v-model="name"
					placeholder="Nom du dossier"
					type="text"
				/>
				<div class="btn-container">
					<p class="submit cancel" @click="$emit('close')">Annuler</p>
					<button class="submit dark">Valider</button>
				</div>
			</form>
		</div>
	</pop-up-wrapper>
</template>


<script>
import { authenticatedApiFetch } from '../../../utils/utils'
import PopUpWrapper from '../PopUpWrapper.vue'
export default {
	components: { PopUpWrapper },
	props: {
		file: Object
	},
	data() {
		return {
			name: ''
		}
	},
	methods: {
		submit: async function () {

			const data = {
				name: this.name,
			}
			authenticatedApiFetch(`/files/${this.file.id}/`, { method: 'PATCH', body: JSON.stringify(data) })
				.then(() => {
					this.$emit('close')
					this.$emit('getFiles', this.name)
				})
		},
	},

	mounted() {
		this.$refs.name.focus()
		this.name = this.file.name
	},



}
</script>

<style>
</style>
